export const DEFAULT_AVATAR =
  "data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\"><circle cx=\"32\" cy=\"16\" r=\"11\" fill=\"%23a0a0a0\"/><path d=\"M14 56V46Q14 34 22 33Q26 38 32 38Q38 38 42 33Q50 34 50 46V56Z\" fill=\"%23a0a0a0\"/></svg>";
